/* eslint-disable @next/next/no-img-element */
import React from "react";
import { LoadingSkeleton } from "@kunduz/ui";
import { useAppContext } from "@kunduz/feature-website-context";
import { useTranslation } from "next-i18next";
import RopeInstallApp from "@icons/ropeInstallApp.svg";
import styles from "./downloadApp.module.scss";
import classNames from "classnames";
import QRCode from "react-qr-code";

export const DownloadApp = (props: Props) => {
  const { student } = useAppContext();
  const { t } = useTranslation("questionIndexing");

  if (student.loading) {
    return <LoadingSkeleton style={{ width: "100%", height: 500 }} />;
  }

  if (student.data && student.data.has_active_device) {
    return null;
  }

  return (
    <section
      data-testid="download-app-install-component"
      className={classNames(styles.container, props.className)}
    >
      <div className={styles.leftContentContainer}>
        <div className={styles.title}>
          {t("under_show_answer_install_component_title")}
        </div>
        <div className={styles.description}>
          {t("under_show_answer_install_component_description")}
        </div>
      </div>
      <div className={styles.rightContentContainer}>
        <div className={styles.qrCodeContainer}>
          {!props.isMobile && (
            <div className={styles.qrCodeImgContainer}>
              <div className={styles.qrWrapper}>
                <QRCode
                  value={t("question_indexing_install_redirection_banner")}
                  size={100}
                />
              </div>
            </div>
          )}
          <RopeInstallApp />
          {!props.isMobile && (
            <div className={styles.qrCodeLabel}>
              {t("under_show_answer_install_component_qr_label")}
            </div>
          )}
        </div>
        <div className={styles.appStoreLogoWrapper}>
          <a
            target="_blank"
            rel="noreferrer"
            href={t("question_indexing_install_redirection_banner")}
            onClick={() => props.sendInstallComponentClickedEvent("app_store")}
          >
            <img loading="lazy" src="/images/applestore.webp" alt="app-store" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={t("question_indexing_install_redirection_banner")}
            onClick={() =>
              props.sendInstallComponentClickedEvent("google_play")
            }
          >
            <img
              loading="lazy"
              src="/images/googleplay.webp"
              alt="play-store"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

interface Props {
  isMobile: boolean;
  sendInstallComponentClickedEvent: (
    buttonType: "app_store" | "google_play",
  ) => void;
  className?: string;
}
